import { League } from '@/types/api.generated';

export const nflFullSeason = (league?: League) => league === League.NflFullSeason || league === League.NflFullseason;

export const isUFC = (league?: League) => league === League.Ufc;

export const isPGA = (league?: League) => league === League.Pga;

export const isTennis = (league?: League) => league === League.Atp || league === League.Wta;

export const isCollegeSport = (league?: League) => league === League.Cfb || league === League.Cbb;

export const isESport = (league?: League) =>
    league && [League.Lol, League.Dota, League.Csgo, League.Valorant, League.Cod, League.RocketLeague].includes(league);
